import React, { Component } from 'react';

class AboutMe extends Component {
  render() {
    const containerStyle = {
      padding: '20px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      lineHeight: '1.6'
    };

    const headerStyle = {
      textAlign: 'center',
      color: '#1f2937',
      marginBottom: '40px',
      fontSize: '32px',
      fontWeight: '700'
    };

    const sectionStyle = {
      backgroundColor: '#fff',
      border: '1px solid #e5e7eb',
      borderRadius: '10px',
      padding: '30px',
      margin: '20px 0',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    };

    const skillStyle = {
      display: 'inline-block',
      backgroundColor: '#2563eb',
      color: 'white',
      padding: '6px 12px',
      borderRadius: '20px',
      fontSize: '14px',
      margin: '4px',
      fontWeight: '500'
    };

    const profileImageStyle = {
      width: '150px',
      height: '150px',
      borderRadius: '50%',
      margin: '0 auto 20px',
      display: 'block',
      backgroundColor: '#f3f4f6',
      border: '4px solid #2563eb',
      fontSize: '60px',
      lineHeight: '142px',
      textAlign: 'center'
    };

    return (
      <div style={containerStyle}>
        <h1 style={headerStyle}>About Me</h1>
        
        <div style={sectionStyle}>
          <div style={profileImageStyle}>👨‍💻</div>
          <h2 style={{ color: '#1f2937', textAlign: 'center', marginBottom: '20px' }}>
            Full Stack Developer & Technology Enthusiast
          </h2>
          <p style={{ fontSize: '18px', color: '#4b5563', textAlign: 'center', marginBottom: '30px' }}>
            Passionate about creating innovative solutions.
          </p>
        </div>

        <div style={sectionStyle}>
          <h3 style={{ color: '#1f2937', marginBottom: '15px' }}>🚀 My Story</h3>
          <p style={{ color: '#4b5563', marginBottom: '15px' }}>
            I am married with a wonderful wife and have a pet dog (Pug).
          </p>
          <p style={{ color: '#4b5563', marginBottom: '15px' }}>
            For a career I am a Data Engineer... at all other times, I prefer to wear all the technology hats. Avid full-stack developer who likes to tinker with technologies.

          </p>
          <p style={{ color: '#4b5563' }}>
            With experience spanning frontend development, backend architecture, cloud 
            infrastructure, and emerging technologies, I enjoy tackling complex challenges 
            and turning innovative ideas into reality. I specialize in AWS tech stack for cloud computing. I enjoy event driven async architecture.
          </p>
        </div>

        <div style={sectionStyle}>
          <h3 style={{ color: '#1f2937', marginBottom: '20px' }}>🛠️ Technical Skills</h3>
          
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ color: '#374151', marginBottom: '10px' }}>Frontend Development</h4>
            <div>
              <span style={skillStyle}>React</span>
              <span style={skillStyle}>JavaScript</span>
              <span style={skillStyle}>TypeScript</span>
              <span style={skillStyle}>HTML5</span>
              {/* <span style={skillStyle}>CSS3</span>
              <span style={skillStyle}>Tailwind CSS</span>
              <span style={skillStyle}>Redux</span> */}
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ color: '#374151', marginBottom: '10px' }}>Backend Development</h4>
            <div>
              <span style={skillStyle}>AWS</span>
              <span style={skillStyle}>Python</span>
              <span style={skillStyle}>Node.js</span>
              <span style={skillStyle}>RESTful APIs</span>
              <span style={skillStyle}>Microservices</span>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ color: '#374151', marginBottom: '10px' }}>Database & Infrastructure</h4>
            <div>
              <span style={skillStyle}>Redshift</span>
              <span style={skillStyle}>S3</span>
              <span style={skillStyle}>DynamoDB</span>
              <span style={skillStyle}>AWS Lambda</span>
              <span style={skillStyle}>AWS Fargate</span>
              <span style={skillStyle}>Docker</span>
              <span style={skillStyle}>AWS+</span>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ color: '#374151', marginBottom: '10px' }}>Tools & Technologies</h4>
            <div>
              <span style={skillStyle}>Git</span>
              <span style={skillStyle}>MCP</span>
              <span style={skillStyle}>AI/ML</span>
              <span style={skillStyle}>Ghidra</span>
              <span style={skillStyle}>IDA Pro</span>
            </div>
          </div>
        </div>

        <div style={sectionStyle}>
          <h3 style={{ color: '#1f2937', marginBottom: '15px' }}>🎯 What I'm Focused On</h3>
          <ul style={{ color: '#4b5563', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>
              Building scalable web applications with modern frameworks and best practices
            </li>
            <li style={{ marginBottom: '8px' }}>
              Exploring AI/ML integration in web applications
            </li>
            <li style={{ marginBottom: '8px' }}>
              DevOps automation and cloud-native architectures
            </li>
            <li style={{ marginBottom: '8px' }}>
              Reverse Engineering
            </li>
          </ul>
        </div>

        <div style={sectionStyle}>
          <h3 style={{ color: '#1f2937', marginBottom: '15px' }}>📫 Let's Connect</h3>
          <p style={{ color: '#4b5563', marginBottom: '20px' }}>
            I'm always interested in discussing new projects, creative ideas, or opportunities 
            to collaborate. Feel free to reach out if you'd like to connect!
          </p>
          <div style={{ textAlign: 'center' }}>
            <a 
              href="https://www.linkedin.com/in/jake-dahl-7b198647/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backgroundColor: '#0066cc',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold',
                marginRight: '10px',
                textDecoration: 'none',
                display: 'inline-block'
              }}
            >
              💼 LinkedIn
            </a>
            <a 
              href="https://github.com/JakeDahl"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backgroundColor: '#333',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold',
                textDecoration: 'none',
                display: 'inline-block'
              }}
            >
              🐙 GitHub
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutMe;
